import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Form,
} from "react-bootstrap";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Modal, TextField, IconButton, MenuItem, Select, FormControl, InputLabel, Menu, Typography } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import moment from "moment";
// import { MenuItem } from "semantic-ui-react";
import CommentIcon from '@mui/icons-material/Comment';
const SubAdminLeadManage = () => {
  const [openModal, setOpenModal] = useState(false);
  const [currentLead, setCurrentLead] = useState(null);

  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [selectedComments, setSelectedComments] = useState([]);
console.log("seleccoment",selectedComments);

  // Function to open the modal with comments
  const handleOpenCommentModal = (comments) => {
    console.log(comments)
    // Split the comments by newline and update state
    setSelectedComments(comments );
    setOpenCommentModal(true);
  };

  // Function to close the modal
  const handleCloseCommentModal = () => {
    setOpenCommentModal(false);
  };

  useEffect(() => {
    const fetchSubAdmins = async () => {
      try {
        const response = await axios.get('/api/admin/all');
        setSubAdmins(response.data.subAdmins);
      } catch (error) {
        console.error('Error fetching admins:', error);
      }
    };
    fetchSubAdmins();
  }, []);

  const [formData, setFormData] = useState({
    studentName: '',
    contactDetails: '',
    subjectPreference: '',
    location: '',
    comments: [],
    TypeOfClass: '',
  });

  const [subAdmins, setSubAdmins] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedLeadId, setSelectedLeadId] = useState(null);

  const [leadMetrics, setLeadMetrics] = useState({
    totalLeads: 0,
    pendingLeads: 0,
    completedLeads: 0,
    conversionRate: 0,
  });

  const handleOpenModal = (lead = null) => {
    setCurrentLead(lead);
    setFormData(lead ? lead : { studentName: '', contactDetails: '', subjectPreference: '', location: '', comments: '', TypeOfClass: '' });
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  const [assignedLeads, setAssignedLeads] = useState([]);
  useEffect(() => {
    fetchAssignedLeads();
  }, []);

  const fetchAssignedLeads = async () => {
    try {
      const response = await axios.get(
        "/api/admin/getLead"
      );
      console.log("Received leads:", response.data.adminLeads);
      setAssignedLeads(response.data.adminLeads);
    } catch (error) {
      console.error(
        "Error fetching assigned leads:",
        error.response ? error.response.data : error.message
      );
    }
  };


  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [selectedTime, setSelectedTime] = useState("");
  const [studentName, setStudentName] = useState("");
  const [contactDetails, setContactDetails] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [date, setDate] = useState([]);
  const [mode, setMode] = useState([]);

  const [demoData, setDemoData] = useState([]);
  console.log("demodata", demoData);

  const [teachers, setTeachers] = useState([]);


  useEffect(() => {
    fettechaer();
  }, []);
  const fettechaer = () => {
    try {
      axios
        .get(`/api/user/getallUser`)
        .then(function (response) {
          if (response.status === 200) {
            console.log(response.data);
            //  localStorage.setItem("userdata",JSON.stringify(response.data.userdata));
            setTeachers(response.data.success);
            return;
          } else {
            //alert("Can't able to fetch ");
            //setdatacondition(true);
            return;
          }
        })
        .catch(function (error) {
          // setdatacondition(true);
          console.log(error.message.data);
          //alert("Can't able to fetch ");
          return;
        });
    } catch (error) {
      console.warn(error);
      alert("Can't able  to fetch ");
      // setdatacondition(true);
      return error;
    }
  };


  const fetchDemo = async () => {
    try {
      const res = await axios.get("/api/admin/getDemo");
      console.log("Get Demo", res);

      setDemoData(res.data);
    } catch (err) {
      console.log("error", err);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await axios.post("/api/admin/scheduleDemo", {
        studentName,
        contactDetails,
        teacher: selectedTeacher,
        scheduledTime: selectedTime,
        date: date,
        classMode: mode,
      });
      console.log("Selected Teacher ID:", selectedTeacher);

      alert("Demo class scheduled successfully!");
      setErrorMessage("");
      fetchDemo();
    } catch (error) {
      setErrorMessage("Failed to schedule demo class.");
      setSuccessMessage("");
      console.error(error); // Add this line to see the full error in console
    }
  };


  useEffect(() => {
    fetchAssignedLeads();
    fetchDemo()
  }, []);

  const [adminLead, setAdminLead] = useState([]);
  console.log(".............",adminLead)
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAssignedLeads = async () => {
      try {
        // Get subAdmin from sessionStorage
        const subAdminData = sessionStorage.getItem("subAdmin");
        if (!subAdminData) {
          console.log("No subAdmin found in sessionStorage");
          return;
        }

        // Parse it to extract subAdminId
        const subAdmin = JSON.parse(subAdminData);
        const subAdminId = subAdmin._id;
        console.log("SubAdmin ID:", subAdminId);

        // Fetch assigned leads
        const response = await fetch(`/api/admin/assignedleads/${subAdminId}`);
        const data = await response.json();
        console.log("............" , data)
        if (response.ok) {
          setAdminLead(data.assignedLeads); // Store leads in state
        } else {
          setError(data.message);
        }
      } catch (error) {
        setError("Failed to fetch assigned leads");
      }
    };

    fetchAssignedLeads();

  }, []);

  const handleChangeDemoStatus = async (id, newDemoStatus) => {
    try {
      console.log("Demo ID:", id);

      const response = await axios.put(
        `/api/admin/updateDemo/${id}`,
        { status: newDemoStatus }
      );

      alert("Status updated successfully!");
      fetchDemo();
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  // const [studentId, setStudentId] = useState('');  // Assuming studentId is set dynamically
  // const [teacherId, setTeacherId] = useState('');  // Assuming teacherId is set dynamically
  const [feedbackByStudent, setFeedbackByStudent] = useState("");
  const [feedbackByTeacher, setFeedbackByTeacher] = useState("");
  const [studentFeedName, setStudentFeedName] = useState(""); // Assuming student name is available
  const [teacherName, setTeacherName] = useState("");
  const [feedback, setFeedback] = useState([]);

  const fetchFeedback = async () => {
    try {
      const response = await axios.get(
        "/api/admin/getFeedback",
        {}
      );
      console.log("Feedback", response);
      setFeedback(response.data);
    } catch (error) {
      console.error("Error fetching feedback:", error);
    }
  };

  useEffect(() => {
    fetchFeedback();
  }, []);

  const handleFeedbackSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "/api/admin/addFeedback",
        {
          feedbackByStudent,
          feedbackByTeacher,
          studentName: studentFeedName,
          TeacherName: teacherName,
        }
      );
      alert("Feedback submitted successfully");
      setFeedbackByStudent("");
      setFeedbackByTeacher("");
      setStudentFeedName("");
      setTeacherName("");
    } catch (error) {
      console.error("Error submitting feedback:", error);
      alert("Error submitting feedback");
    }
  };



  const handleChangeLeadStatus = async (leadId, newStatus) => {
    try {

      const response = await axios.put(
        `/api/admin/updateLeadStatus/${leadId}`,
        { status: newStatus }
      );
      alert('Status updated successfully!');
      fetchAssignedLeads();
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  const handleSubmitedit = async (e) => {
    e.preventDefault();
    const url = currentLead
      ? `/api/admin/editLead/${currentLead._id}`
      : '/api/admin/addLead';
    const method = currentLead ? 'PUT' : 'POST';

    try {
      const response = await axios({
        method,
        url,
        headers: {
          'Content-Type': 'application/json',
        },
        data: formData,
      });
      if (response.status === 200) {
        alert(response.data.message);
        fetchAssignedLeads();
        handleCloseModal();
        window.location.reload();
      }

    } catch (error) {
      console.error('Error saving lead:', error);
    }
  };




  const handleCommentAdd = async (e) =>{
    e.preventDefault();

    if (!formData.comments.trim()) {
      alert('Please enter a comment!');
      return;
    }
    console.log( "qwertyuio",formData.comments)

    const payload = { comments: formData.comments.trim() };

    try {
      // Call the backend API to add the comment
      const res = await axios.post(`/api/admin/addComments/${currentLead._id}`, payload)
      console.log(res )
      console.log( "qwertyuio",formData.comments)
      setFormData({ comment: '' }); // Reset comment field after submission
      fetchAssignedLeads();
      
      handleCloseModal(); // Close the modal
    } catch (error) {
      console.error('Failed to add comment:', error);
    }
  }


  return (
    <>
      <div className="container mt-5">
        <h3 style={{ color: "#00a695" }}>Assigned Leads</h3>
        {/* <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Student Name</th>
              <th>Contact Details</th>
              <th>Subject Preferences</th>
              <th>Location</th>
              <th>Type of Class</th>
              <th>Status</th>
              <th>Assigned SubAdmin</th>
            </tr>
          </thead>
          <tbody>
            {assignedLeads.map((lead, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{lead.studentName}</td>
                <td>{lead.contactDetails}</td>
                <td>{lead.subjectPreference}</td>
                <td>{lead.location}</td>
                <td>{lead.TypeOfClass}</td>
                <td>{lead.status}</td>
                <td>
                  {lead.assignedTo ? lead.assignedTo.name : "Not Assigned"}
                </td>
              </tr>
            ))}
          </tbody>
        </Table> */}
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.No</TableCell>
                <TableCell>Student Name</TableCell>
                <TableCell>Contact Details</TableCell>
                <TableCell>Subject Preferences</TableCell>
                <TableCell>Location</TableCell>
                <TableCell>ModeOf Class</TableCell>
                {/* <TableCell>Assign Lead</TableCell> */}
                <TableCell>Status</TableCell>
                <TableCell>Comments</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {adminLead.map((lead, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{lead.studentName}</TableCell>
                  <TableCell>{lead.contactDetails}</TableCell>
                  <TableCell>{lead.subjectPreference}</TableCell>
                  <TableCell>{lead.location}</TableCell>
                  <TableCell>{lead.TypeOfClass}</TableCell>

                  <TableCell>
                    <FormControl fullWidth>
                      <InputLabel>Status</InputLabel>
                      <Select
                        value={lead.status}
                        onChange={(e) => handleChangeLeadStatus(lead._id, e.target.value)}
                        label="Status"
                      >
                        <MenuItem value="Pending">Pending</MenuItem>
                        <MenuItem value="Demo Fixed">Demo Fixed</MenuItem>
                        <MenuItem value="Demo Completed">Demo Completed</MenuItem>
                        <MenuItem value="Demo Converted">Demo Converted</MenuItem>
                        <MenuItem value="Lost">Lost</MenuItem>
                      </Select>
                    </FormControl>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant="outlined"
                      style={{ color: "#00a695", borderColor: "#00a695" }}
                      onClick={() => handleOpenCommentModal(lead.comments)}
                    >
                      View
                    </Button>
                  </TableCell>
                  <TableCell>
                    {/* <IconButton style={{ color: '#00a695' }} onClick={() => handleOpenModal(lead)}>
                                        <Edit />
                                    </IconButton> */}
                    <IconButton style={{ color: '#00a695' }} onClick={() => handleOpenModal(lead)}>
                      <CommentIcon />
                    </IconButton>
                    {/* <IconButton style={{ color: 'red' }} onClick={() => handleDelete(lead._id)}>
                                        <Delete />
                                    </IconButton> */}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Modal open={openModal} onClose={handleCloseModal}>
          <Paper style={{ padding: '16px', margin: 'auto', marginTop: '16px', maxWidth: '400px' }}>
            <h3>Add Comment</h3>
            <form onSubmit={handleCommentAdd}>
              <TextField
                label="Comment"
                name="comments"
                // value={formData.comments} 
                onChange={handleChange}
                fullWidth
                margin="normal"
                required
              />
              <Button
                className='mt-2'
                type="submit"
                variant="contained"
                style={{ backgroundColor: "#00a695" }}
              >
                Add Comment
              </Button>
            </form>
          </Paper>
        </Modal>

      </div>

      <div className="container mt-5 mb-5">
        <h3 style={{ color: "#00a695" }}>Schedule Demo Class</h3>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="studentName">
            {/* Text input for manual entry */}
            {/* <Form.Control
        type="text"
        placeholder="Enter student name"
        value={studentName}
        onChange={(e) => setStudentName(e.target.value)}
        required
        className="mb-3 w-50"
      /> */}

            {/* Dropdown for selecting student */}
            <Form.Control
              as="select"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
              required
              className="mb-3 w-50"
            >
              <option value="">Select Student</option>
              {Array.isArray(adminLead) &&
                adminLead.map((student) => (
                  <option key={student?._id} value={student?.studentName}>
                    {student?.studentName}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="contactDetails">
            <Form.Control
              type="text"
              placeholder="Enter contact details"
              value={contactDetails}
              onChange={(e) => setContactDetails(e.target.value)}
              required
              className="mb-3 w-50"
            />
          </Form.Group>

          <Form.Group controlId="teacherSelect">
            <Form.Control
              as="select"
              value={selectedTeacher}
              onChange={(e) => setSelectedTeacher(e.target.value)}
              required
              className="mb-3 w-50"
            >
              <option value="">Select Teacher</option>
              {Array.isArray(teachers) ? (
                teachers.map((teacher) => (
                  <option key={teacher._id} value={teacher._id}>
                    {teacher.name}
                  </option>
                ))
              ) : (
                <option disabled>No teachers available</option>
              )}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="mode">
            <Form.Control
              type="text"
              value={mode}
              placeholder="Class Mode"
              onChange={(e) => setMode(e.target.value)}
              className="mb-3 w-50"
            ></Form.Control>
          </Form.Group>

          <Form.Group controlId="date">
            <Form.Control
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              className="mb-3 w-50"
            />
          </Form.Group>

          <Form.Group controlId="time">
            <Form.Control
              type="time"
              value={selectedTime}
              onChange={(e) => setSelectedTime(e.target.value)}
              required
              className=" w-50"
            />
          </Form.Group>

          <Button
            className="mt-3"
            type="submit"
            style={{ backgroundColor: "#00a695", color: "white", border: "0" }}
          >
            Schedule Demo
          </Button>
        </Form>

        {successMessage && <p style={{ color: "green" }}>{successMessage}</p>}
        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
      </div>

      <div className="container mt-5 mb-5">
        <h3 style={{ color: "#00a695" }}>Demo Class Details</h3>
        <Table striped bordered hover>
          <thead>
            <tr className="text-center">
              <th>S.No</th>
              <th>Student Name</th>
              <th>Contact Details</th>
              <th>Teacher</th>
              <th>Status</th>
              <th>Mode</th>
              <th>Date</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody className="text-center">
            {demoData.map((lead, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{lead.studentName}</td>
                <td>{lead.contactDetails}</td>
                <td>{lead.teacher}</td>
                <td>
                  <select
                    className="form-select"
                    value={lead.status}
                    onChange={(e) =>
                      handleChangeDemoStatus(lead._id, e.target.value)
                    }
                  >
                    <option value="Demo Scheduled">Demo Scheduled</option>
                    <option value="Demo Completed">Demo Completed</option>
                    <option value="Demo Converted">Demo Converted</option>
                    <option value="Not Interested">Not Interested</option>
                  </select>
                </td>
                <td>{lead.classMode}</td>
                <td>
                  {lead.date ? moment(lead.date).format("MM/DD/YYYY") : "N/A"}
                </td>{" "}
                <td>{lead.scheduledTime}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <div className="container mt-4">
        <h3 style={{ color: "#00a695" }}>Add Feedback</h3>
        {/* Form for submitting feedback */}
        <form onSubmit={handleFeedbackSubmit} className="mb-4">
          <div className="row">
            <div className="col-md-6 mb-3">
              <select
                className="form-control mt-2"
                value={studentFeedName}
                onChange={(e) => setStudentFeedName(e.target.value)}
              >
                <option value="">Select Student</option>
                {Array.isArray(adminLead) &&
                  adminLead.map((student) => (
                    <option key={student?._id} value={student?.studentName}>
                      {student?.studentName}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-md-6 mb-3">
         {/* <label htmlFor="teacherName" className="form-label">
        Teacher Name
      </label>
      <input
        type="text"
        id="teacherName"
        className="form-control"
        value={teacherName}
        onChange={(e) => setTeacherName(e.target.value)}
        placeholder="Enter Teacher Name"
        required
      /> */}

              {/* Dropdown for selecting a teacher */}
              <select
                className="form-control mt-2"
                value={teacherName}
                onChange={(e) => setTeacherName(e.target.value)}
              >
                <option value="">Select Teacher</option>
                {Array.isArray(teachers) && teachers.length > 0 ? (
                  teachers.map((teacher) => (
                    <option key={teacher._id} value={teacher.name}>
                      {teacher.name}
                    </option>
                  ))
                ) : (
                  <option disabled>No teachers available</option>
                )}
              </select>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="feedbackByStudent" className="form-label">
                Student Feedback
              </label>
              <textarea
                id="feedbackByStudent"
                className="form-control"
                rows="3"
                value={feedbackByStudent}
                onChange={(e) => setFeedbackByStudent(e.target.value)}
                placeholder="Enter your feedback"
                required
              />
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="feedbackByTeacher" className="form-label">
                Teacher Feedback
              </label>
              <textarea
                id="feedbackByTeacher"
                className="form-control"
                rows="3"
                value={feedbackByTeacher}
                onChange={(e) => setFeedbackByTeacher(e.target.value)}
                placeholder="Enter your feedback"
                required
              />
            </div>
          </div>
          <button
            type="submit"
            className="btn"
            style={{ backgroundColor: "#00a695", color: "white" }}
          >
            Submit Feedback
          </button>
        </form>
        {feedback && (
          <div>
            <div className="table-responsive">
              <h2 style={{ color: "#00a695" }}>Student Feedback Details</h2>
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Student Name</th>
                    <th>Feedback</th>
                  </tr>
                </thead>
                <tbody>
                  {feedback.map((feedbackItem, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{feedbackItem.studentName}</td>
                      <td>{feedbackItem.feedbackByStudent}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="table-responsive">
              <h2 style={{ color: "#00a695" }}>Teacher Feedback Details</h2>
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Teacher Name</th>
                    <th>Feedback</th>
                  </tr>
                </thead>
                <tbody>
                  {feedback.map((feedbackItem, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{feedbackItem.TeacherName}</td>
                      <td>{feedbackItem.feedbackByTeacher}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <Modal open={openCommentModal} onClose={handleCloseCommentModal}>
        <Paper style={{ padding: '16px', margin: 'auto', marginTop: '16px', maxWidth: '400px' }}>
          <h3>All Comments History</h3>
          {selectedComments.length > 0 ? (
        selectedComments.map((comment, index) => (
          <ul key={index} style={{ marginBottom: '10px' }}>
        <li>{}-{comment}</li>
          </ul>
        ))
      ) : (
        <p>No comments available.</p>
      )}
          <Button variant="contained" color="primary" onClick={handleCloseCommentModal}>
            Close
          </Button>
        </Paper>
      </Modal>
    </>
  );
};

export default SubAdminLeadManage;
